import { Component, ViewChild, ViewContainerRef, HostListener, AfterViewInit, ChangeDetectorRef, ComponentFactoryResolver, Output, EventEmitter, ElementRef } from '@angular/core';
import { NavController, NavParams, Nav, ModalController, AlertController, ToastController } from 'ionic-angular';
import { ContextMenuService, ContextMenuComponent } from 'ngx-contextmenu';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { DriveServiceProvider } from '../../providers/drive-service/drive-service';
import { StoreWrapProvider } from '../../providers/store-wrap/store-wrap';
import { Events } from 'ionic-angular';
import { DriveSharePage } from '../../pages/drive-share/drive-share';
import { TemplateListsPage } from '../../pages/template-lists/template-lists';

import { ConfigureServiceProvider } from '../../providers/configure-service/configure-service';
import { ConfigApiServiceProvider } from '../../providers/config-api-service/config-api-service';

import { componentHolderService } from '../../providers/component-holder.service/component-holder.service';
import { RuleEngineSetupComponent } from '../../components/rule-engine-setup/rule-engine-setup';
import { ExcelUploadPage } from '../../pages/excel-upload/excel-upload';
import { FolderPropertiesComponent } from '../../components/folder-properties/folder-properties';
import { ExcelService } from '../../providers/excel-service/excel-service';
import * as fs from 'file-saver';
import { VersionHistoryComponent } from '../../components/version-history/version-history';
import { DomSanitizer } from '@angular/platform-browser';
import { EncrDecrServiceProvider } from '../../providers/encr-decr-service/encr-decr-service';
import { EventServiceProvider } from '../../providers/event-service/event-service';
import { LoginService } from '../../providers/login-service/login-service';
import { JsonpClientBackend } from '@angular/common/http';
import { CommunicationServiceProvider } from '../../providers/communication-service/communication-service';
@Component({
  selector: 'page-drive',
  templateUrl: 'drive.html'
})

export class DrivePage implements AfterViewInit {
  @ViewChild(Nav, { read: ViewContainerRef, static: false }) nav: Nav;
  @ViewChild(ContextMenuComponent, { static: true }) public basicMenu: ContextMenuComponent;
  @ViewChild('otherMenu', { static: true }) public otherMenu: ContextMenuComponent;


  showPaste: any = false;
  showTempList: any = false;
  SearchText: any;
  showTemplateStatus = false;
  showProgressStatus = false;
  showListView: any = false;
  objFilterParams: any = [];
  showClickedFiles: any;
  showMainContainer = true;
  showComponentHolder = false;
  showSplitContainer: any = false;
  componentRef: any;
  page_Hide: any;
  head_width: boolean = false;
  selectedFolder: any;
  showChatFilter: boolean = false;
  contextMenuFolder = []
  showFolderMenu: boolean = false;
  objCurrentFolderProperties: any;
  topStylePixel: any = 0;
  leftStylePixel: any = 0;
  bottomStylePixel: any = 0;
  rightStylePixel: any = 0;
  currentFolderShareId: any;
  objCurrentFolder: any;
  oldFolderName: any = '';
  objCurrentParentFolder: any;
  objSelectedFolder: any;
  showWindowContextMenu: boolean = false;
  showMultitemp: boolean = false;
  public items = [];
  multiTemplateList: any = [];
  templateSelection: any;
  folderStatusMove: boolean = false;
  templateID: any;
  templateProperty: any;
  sideWidth: any;
  components: any;
  screenWidth: any;
  visibleRuleEngine: boolean = true;
  objMovedSourceFolder: any = {};
  inlineEditAccess: any;
  tempName: any;
  currentTemplateProps: any = [];
  visiblePtoperties: boolean = true;
  rowData: any;
  template_id: any;
  folderProperty: boolean = false;
  row_index: any = [];
  ShowTntActivity: boolean = false;
  @Output() pullTntData = new EventEmitter<any>();
  @ViewChild(ContextMenuComponent, { static: true }) public contextMenu: ContextMenuComponent;
  hiddenRuleengineMobile: boolean;
  showImportPopup: boolean;
  ImportFolder: any;
  tmAppUrl: string;
  urlSafe: any;
  showTemplates: boolean;
  exportfolderStatus: any;
  driveWidth: any;
  ShareID: any;
  objShareInfo: any = [];
  objShareInformation: any = [];
  receiverEmailId: any = [];
  subtemplateid = "";
  watchTab: boolean = false;
  broadcastSubs: any;
  watchuserEmaillist: any = [];
  constructor(public communicationServ: CommunicationServiceProvider, private eventObj: EventServiceProvider, private loginServ: LoginService, public elem: ElementRef, public sanitizer: DomSanitizer, private EncrDecrService: EncrDecrServiceProvider, public configServiceProvider: ConfigureServiceProvider, public driveService: DriveServiceProvider, public configApiService: ConfigApiServiceProvider, private contextMenuService: ContextMenuService, public navCtrl: NavController, public events: Events, private cdr: ChangeDetectorRef, public configureService: ConfigureServiceProvider, public navParams: NavParams, public http: Http, public driveServiceProvider: DriveServiceProvider, private modal: ModalController, private alertCtrl: AlertController, private storeWrap: StoreWrapProvider, public toastController: ToastController, private componentService: componentHolderService, private resolver: ComponentFactoryResolver, private excelService: ExcelService) {
  }
  onContextMenu($event) {
    this.showWindowContextMenu = true;
  }
  ngOnInit() {

    this.broadcastSubs = this.communicationServ.getInstance()
    .subscribe((data: any) => {
      if (data.src === "versionHistory") {
        if (data.event === 'closeVersionHistoryPanel') {
          let flag = data['status'];
          if (flag) {
            if (flag.isTrusted == true) {
              this.ShowTntActivity = false;
              this.closeTntComponent();
            }else{
              this.ShowTntActivity = false;
            }
          }
        }
      }

      if (data.src === "sidePanel") {
        if (data.event === 'showPage') {
          if (data['data'] == true) {
            this.driveWidth = 'drive_width'
            this.head_width = true;
          } else {
            this.driveWidth = ''
            this.head_width = false;
          }
        }
      }

      if (data.src === "header") {
        if (data.event === 'ExportFolder') {
          let exportfolderStatus = data['exportfolderStatus'];
          let status = data['status'];
          this.exportfolderStatus = exportfolderStatus;
          if (status == true) {
            this.exportFolder()
          }
        }
      }

      if (data.src === "iframeData") {
        if (data.event === 'excelTemplateauto') {
          let status = data['status'];
          let folderName = data['folderName'];
          let template = data['template']
          let excelFile = data['excelFile']
          if (status == true && this.configApiService.excelTemplateStatus == true) {
            let foldername: any = this.driveServiceProvider.objCurrentFolder["folders"].find(item => item.name == folderName);
            if (foldername) {
              const toast = this.toastController.create({
                message: 'Folder Name already exists. Please, create new foldername',
                duration: this.configApiService.toastDuration
              });
              toast.present();
            } else {
              this.driveServiceProvider.objCurrentFolder = this.driveServiceProvider.objRootFolder;
              this.driveService.createFolder(folderName)
              this.driveServiceProvider.objCurrentFolder["folders"].forEach(element => {
                if (element.name == folderName) {
                  this.objCurrentFolder = element;
                  localStorage.setItem('currentFolderData',JSON.stringify(element))
                  this.updateFolderProperties(status, template)
                }
              })
              this.objCurrentFolder.template = []
              this.objCurrentFolder.template.push(this.driveService.storeWrap.storeTemplates[template[0].id])
              var formData = new FormData();
              formData.append('file', excelFile);
              formData.append('accessType', 'addNew');
              formData.append('FolderJSON', JSON.stringify(this.objCurrentFolder));
              console.log(this.objCurrentFolder)
              this.configApiService.uploadExcelData(formData, this.cbk)
            }
            this.configApiService.excelTemplateStatus = false
          }
        }
      }
      if (data.src === "breadCrumbs") {
        if (data.event === 'openFolderProperties') {
          let flag = data['status'];
          if (flag) {
            this.openContextMenu(flag)
          } else {
            this.folderProperty = false;
          }
        }
        //  else if(data.event === 'folderSearch'){
        //   this.driveService.folderSearch = data.serachValue
        // }
      }
    });

    this.driveServiceProvider.getSideBar.subscribe((res: string) => {
      this.sideWidth = res;
    })
    this.screenWidth = window.innerWidth;
    if (window.innerWidth > 700) {
      this.head_width = false;
      this.hiddenRuleengineMobile = true;
    } else {
      this.head_width = true;
      this.hiddenRuleengineMobile = false;
    }
    this.driveServiceProvider.getInstance()
      .subscribe((flag: any) => {
        this.driveServiceProvider.objCurrentFolder.files = [];
        this.showMainContainer = !flag;
        this.showComponentHolder = flag;
        if (this.showComponentHolder == false) {
          this.getAllfiles();
        }
      })
    this.driveService.customObservable.subscribe((res) => {
      this.eventObj.trigEvent({ event: "epcDesk_CMD", data: { cmd: "logout" } });
      this.loginServ.isReg();
      this.driveService.objCurrentFolder = this.driveService.getFolderStructure();
      this.driveService.objRootFolder = this.driveService.getFolderStructure(); 
    })
  }
  ngAfterViewInit() {

    this.get_Width();

    if (this.driveServiceProvider.objRootFolder.name != "Drive" || this.driveServiceProvider.objRootFolder.name == "") {
      this.driveServiceProvider.objRootFolder = this.driveServiceProvider.getFolderStructure();
      this.driveServiceProvider.objCurrentFolder = this.driveServiceProvider.objRootFolder;
      this.driveServiceProvider.gotoFolder(null);
      this.driveServiceProvider.getDriveRootFolders({}, () => {
        this.driveServiceProvider.gotoFolder(null);
        this.driveService.broadcastInfo({ src: 'drive', event: 'currentFolder', currentFolder: this.driveServiceProvider.objCurrentFolder });
      });
    }
    /***********
     * Check rootfolder is drive and set objCurrentFolder same as root folder json
     * ***********/
    else if (this.driveServiceProvider.objRootFolder.name == "Drive" && this.driveServiceProvider.objCurrentFolder.folder_id != 0) {
      this.driveServiceProvider.objCurrentFolder = this.driveServiceProvider.objRootFolder;
      this.driveService.broadcastInfo({ src: 'drive', event: 'currentFolder', currentFolder: this.driveServiceProvider.objCurrentFolder });
      this.driveServiceProvider.gotoFolder(null);
    } else if (this.driveServiceProvider.objCurrentFolder.folder_id == 0) {
      this.driveService.broadcastInfo({ src: 'drive', event: 'currentFolder', currentFolder: this.driveServiceProvider.objCurrentFolder });
    }
    /***************end of santhiya code*********** */

    this.objCurrentFolder = this.driveServiceProvider.getFolderStructure()
    this.get_Width();

    this.initDriveEvents();

    this.showWindowContextMenu = true;
    this.cdr.detectChanges();

    /* * * * * * * * *
   * Get app components from component holder service
   * * * * * * * * */

    this.broadcastSubs = this.communicationServ.getInstance()
      .subscribe((data: any) => {
        if (data.src === "defaultProps") {
          if (data.event === 'pullAppComponents') {
            let flag = data['status'];
            if (flag) {
              this.driveService.broadcastInfo({ src: 'comp-main', event: 'getAppComponents', status: true, components: this.components });
            }
          }
        }
      })
    window.addEventListener('contextmenu', function (e) {
      e.preventDefault();
    }, false);

    this.driveServiceProvider.activePageStatus = true
  }

  initDriveEvents() {

    this.broadcastSubs = this.communicationServ.getInstance()
      .subscribe((data: any) => {
        if (data.src === "main") {
          if (data.event === 'showListView') {
            if (data['data']) {
              this.loadGridData();
            } else {
              this.showListView = false;
            }
          }
        }
        if (data.src === "drive-main") {
          if (data.event === 'folderPropertyClose') {
            let status = data['status'];
            if (status == true) {
              this.viewContainerRef.clear();
              this.showMainContainer = true;
            }
          } else if (data.event === 'showComponentHolder') {
            let flag = data['status'];
            this.showMainContainer = flag == true ? false : true;
            this.showComponentHolder = flag;
            this.subtemplateid = "";
            if (this.showComponentHolder == true) {
              this.driveService.broadcastInfo({ src: 'main', event: 'headerShow', data: false });
              this.driveService.broadcastInfo({ src: 'sidePanelShow', event: 'sideBarShow', status: false });
            }
          } else if (data.event === "showProgressStatus") {
            let status = data['status'];
            this.showProgressStatus = status;
          } else if (data.event === 'showTemplateStatus') {
            let status = data['status']
            if (status == 'watchTab') {
              this.showTemplateStatus = false;
              this.watchTab = true;
            } else {
              this.showTemplateStatus = status;
            }
            this.templateSelection = 'New';
          } else if (data.event === "updateFolderProperties") {
            let status = data['status'];
            let selectedTemplates = data['selectedTemplates']
            this.updateFolderProperties(status, selectedTemplates)
            data.event = "";
          }else if(data.event === "formGridTNTChat") {
            this.subtemplateid = data.templateID;
            this.chatTntActivity(data.index)
          }
        }
      });
  }

  getAllfiles() {
    this.driveService.broadcastInfo({ src: 'main', event: 'headerShow', data: true });
  }

  loadGridData() {
    const OBJLEN = 0;
    this.driveService.folderSearch = ''
    if (Object.keys(this.driveService.objBckupObjFolerProperties).length !== OBJLEN && this.driveServiceProvider.objCurrentFolder.template.length == 0) {
      this.driveServiceProvider.objCurrentFolder.template = JSON.parse(this.driveService.objBckupObjFolerProperties)['template']
    }
    this.showListView = false;
    let __self = this;
    setTimeout(() => {
      this.driveServiceProvider.CurrentFilesData = [];
      if (__self.driveServiceProvider.objCurrentFolder.template.length) {
        __self.templateID = __self.driveServiceProvider.objCurrentFolder.template[0].id;
        __self.templateProperty = __self.driveServiceProvider.storeWrap.storeTemplates[__self.templateID];
        if (__self.templateProperty) {
          if (Object.keys(__self.templateProperty.colprops).length) {
            __self.showListView = true;

          }
        }
      }
    }, 100);
  }

  updateFolderProperties(status, selectedTemplates) {
    this.showMultitemp = status;
    let objCurrentFolder = JSON.parse(localStorage.getItem('currentFolderData'))
    let arrTemplateProps = [];
    for (var i = 0; i < selectedTemplates.length; i++) {
      arrTemplateProps.push({ 'id': selectedTemplates[i].id, 'filterParams': selectedTemplates[i].filterParams })
    }
    this.driveServiceProvider.assignTemplateToFolder(arrTemplateProps, objCurrentFolder, () => {
    })
  }
  showFolderContent(e, clickedFolder, index) {
    let data = clickedFolder;
    localStorage.setItem('currentFolderData',JSON.stringify(data))
    if (data.template != undefined && data.template.length != 0) {
      if (this.currentTemplateProps != undefined) {
        this.visiblePtoperties = this.currentTemplateProps.templateName == "Blank" ? false : true;
        this.visibleRuleEngine = data.template.length == 0 || this.currentTemplateProps.templateName == "Blank" ? false : true;
      } else {
        this.visibleRuleEngine = false;
      }
    } else {
      this.visibleRuleEngine = false;
    }
    this.driveServiceProvider.objOpenFolder = JSON.stringify(clickedFolder);
    this.objCurrentParentFolder = this.driveServiceProvider.getCurrentParentFolder(index);
    if (clickedFolder.folder_type === 'smart_folder') {
      let template = clickedFolder['template'];
      template[template.length - 1]
      let filterParams = template[template["length"] - 1].filterParams;
      this.showAllFiles(clickedFolder);
      this.driveServiceProvider.showContentSmartFolder(0, filterParams);
      this.showListView = false;
      this.driveServiceProvider.gotoFolder(clickedFolder);
    } else {
      this.showListView = false;

      this.driveServiceProvider.gotoFolder(clickedFolder);
      this.objFilterParams = this.driveServiceProvider.getFileNameParam();
      this.loadGridData();


    }
  }

  showAllFiles(clickedFolder) {
    if (clickedFolder.template.length > 0) {
      this.selectedFolder = clickedFolder.template[0].templateName;
    }
    if (clickedFolder.template.length <= 0) {
      if (clickedFolder.folder_id !== 0) {
        this.driveServiceProvider.broadcastInfo({ src: 'drive-main', event: 'showTemplateStatus', status: true });
      } else {
        this.driveServiceProvider.broadcastInfo({ src: 'drive-main', event: 'showTemplateStatus', status: false });
      }
    } else {
      this.showListView = false;
      if (clickedFolder.template.length) {
        this.driveServiceProvider.pullSyncData(0, null, clickedFolder, this.storeWrap.typeOfApi.summary, this.storeWrap.typeOfData.typeFile, this.getFileData)
      }

    }
  }

  getFileData = ((data) => {
    this.driveServiceProvider.CurrentFilesData = data[0];
    if (data.length > 0) {
      this.showListView = true;
    }
  })


  get_Width() {
    this.broadcastSubs = this.communicationServ.getInstance()
      .subscribe((data: any) => {
        if (data.src === "header") {
          if (data.event === 'Hidepage') {
            let status = data['data'];
            if (status == true) {
              if (document.getElementById("headerw").style.width == '90%') {
                this.head_width = true;
              }
            } else {
              this.page_Hide = true;
              if (document.getElementById("headerw").style.width == '100%') {
                if (window.innerWidth > 700) {
                  this.head_width = false;
                } else {
                  this.head_width = true;
                }
              }
            }
          }
        }
      });
  }


  toggle() {
    if (this.showChatFilter == false) {
      this.showChatFilter = true;
    } else if (this.showChatFilter == true) {
      this.showChatFilter = false;
    }
  }


  /* * * * * *
  * Context Menu 
  * * * * * */
  openFolderMenu(e, data, index) {
    this.objCurrentParentFolder = this.driveServiceProvider.getCurrentParentFolder(index);
    this.objCurrentFolder = data;
    localStorage.setItem('currentFolderData',JSON.stringify(data))
    if (data.template.length != 0) {
      this.currentTemplateProps = this.driveServiceProvider.storeWrap.storeTemplates[data.template[0].id];
    }
    this.openFolderProperties()
  }

  openFolderProperties() {
    let data = this.objCurrentFolder;
    if (data.template != undefined && data.template.length != 0) {
      if (this.currentTemplateProps != undefined) {
        this.visiblePtoperties = this.currentTemplateProps.templateName == "Blank" ? false : true;
        this.visibleRuleEngine = data.template.length == 0 || this.currentTemplateProps.templateName == "Blank" ? false : true;
      } else {
        this.visibleRuleEngine = false;
      }
    } else {
      this.visibleRuleEngine = false;
    }
    this.oldFolderName = data['name'];
    this.objCurrentFolderProperties = data;
    return false;
  }

  editFolderPopup(e) {
    this.showFolderMenu = false;
    this.folderProperty = false;
    let alert = this.alertCtrl.create({
      title: 'Rename',
      inputs: [
        {
          name: 'Name',
          value: this.oldFolderName
        }
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel'
        },
        {
          text: 'Ok',
          handler: data => {
            this.driveServiceProvider.renameFolder(this.objCurrentFolder, this.objCurrentFolder.template, data.Name);
          }
        }
      ]
    });
    alert.present();
  }

  sharePopup(event) {
    this.driveService.getShareUserList(this.objCurrentFolder, this.configServiceProvider.getLoginUserID(), this.pullsubmitSuccess);
    if (this.objCurrentFolderProperties.template.length == 0) {
      this.objCurrentFolderProperties.template = JSON.parse(this.driveService.objBckupObjFolerProperties)['template']
    }
    if (this.objCurrentFolderProperties && this.objCurrentFolderProperties.folders != undefined) {
      var datas = this.objCurrentFolderProperties.folders;
      datas.forEach(element => {
          Object.keys(element).forEach(key => {
              if (key == 'files') {
                  element[key] = [];
              }
              if (key == 'folder') {
                  element.forEach(folder => {
                      Object.keys(folder).forEach(key => {
                          if (key == 'files') {
                              element[key] = [];
                          }
                      });
                  });
              }
          });
      });
      this.objCurrentFolderProperties['files'] = [];
      this.objCurrentFolderProperties.folders = datas;
    }
    this.folderProperty = false;
    this.driveServiceProvider.objCurrentFolder['files'] = [];
    let templateProperty: any = [];
    // this.driveServiceProvider.objCurrentFolder.template = this.objCurrentFolderProperties.template;
    if (this.objCurrentFolderProperties.template.length > 1) {
      this.objCurrentFolderProperties.template.forEach(element => {
        templateProperty.push(this.storeWrap.storeTemplates[element.id]);
      });
    } else if (this.objCurrentFolderProperties.template.length == 1) {
      templateProperty.push(this.storeWrap.storeTemplates[this.objCurrentFolderProperties.template[0].id]);
    }
    let data = Object.assign({}, this.configApiService.driveApi.pushLinkShareUser.params, {
      "RecordID": '',
      "ShareID": this.ShareID != undefined ? this.ShareID : '',
      "ShareType": 'Folder',
      "ReceiverEmail": this.objShareInformation != undefined ? this.objShareInformation : [],
      "UserFolder": this.objCurrentFolder['folder_id'],
      "TemplateID": this.objCurrentFolderProperties.template[0].id,
      "TemplateName": this.objCurrentFolderProperties.template[0].templateName,
      "userid": this.configureService.getLoginUserID(),
      "SharedInfo": { 'sharedFolder': this.objCurrentFolderProperties, 'accessType': 'private', 'pullFolderTemplate': { "client": this.configureService.getStudio(), 'userid': this.configureService.getLoginUserID(), 'app_code': this.configApiService.currentDriveApp['app_code'] } }
    })
    var modalPage = this.modal.create(DriveSharePage, { 'shareDataSet': data, "ShareType": 'Folder', 'ShareID': this.ShareID != undefined ? this.ShareID : '', 'currentFolderName': this.objCurrentFolderProperties.name,"currentFolder": this.objCurrentFolder }, { cssClass: "data_Share", showBackdrop: true, enableBackdropDismiss: false });
    modalPage.present();
    modalPage.onDidDismiss(data => {
      this.driveService.objBckupObjFolerProperties = JSON.stringify(this.objCurrentFolderProperties)
      // this.driveServiceProvider.objCurrentFolder.template = []; 
    });
  }

  deleteFolderPopup(e) {
    this.showFolderMenu = false;
    this.folderProperty = false;
    let alert = this.alertCtrl.create({
      title: 'Are you sure, want to delete the folder ?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel'
        },
        {
          text: 'Ok',
          handler: data => {
            let getAllTrackerFolder = this.driveServiceProvider.getAllTrackerFolder;
            if (Object.keys(getAllTrackerFolder).length != 0) {
              let selectedFolderIndex = getAllTrackerFolder.findIndex(elem => elem.folder_id == this.objCurrentFolder.folder_id)
              if (selectedFolderIndex != -1) {
                let selectedFolder = getAllTrackerFolder[selectedFolderIndex];
              }
            }
            this.driveServiceProvider.deleteFolder(this.objCurrentFolder);
            if (this.objCurrentFolder["author"] != '') {
              this.driveService.getShareUserList(this.objCurrentFolder, this.objCurrentFolder["author"]['userID'], this.pullsubmitSuccess);
            }
          }
        }
      ]
    });
    alert.present();
  }

  copyFolder(e) {

    this.objSelectedFolder = this.objCurrentFolderProperties;
    this.showPaste = true;
    this.folderProperty = false;
    this.showFolderMenu = false;
    const toast = this.toastController.create({
      message: 'Folder copy feature on processing',
      duration: this.configApiService.toastDuration
    });
    this.showFolderMenu = false;
    toast.present();
  }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {

    if (event.key === 'escape' || 'Esc') {
      if (this.showFolderMenu == true) {
        this.showFolderMenu = false;
      }
    }
  }

  moveFolder(event) {
    this.objMovedSourceFolder = this.driveServiceProvider.getMoveSourceFolder();
    this.driveServiceProvider.objCurrentFolder.folders = this.driveServiceProvider.objCurrentFolder.folders.filter(item => item.folder_id != this.objCurrentFolderProperties.folder_id);
    this.objSelectedFolder = this.objCurrentFolderProperties;
    this.showPaste = true;
    this.showFolderMenu = false;
    this.folderProperty = false;
    const toast = this.toastController.create({
      message: 'Folder Moving feature on processing',
      duration: this.configApiService.toastDuration
    });
    this.showFolderMenu = false;
    toast.present();
    this.folderStatusMove = true;
  }

  pasteFolder(e) {
    this.driveServiceProvider.objCurrentFolder;
    if (this.folderStatusMove == false) {
      this.driveServiceProvider.moveFolder(this.objSelectedFolder, this.driveServiceProvider.objCurrentFolder, false);
    } else if (this.folderStatusMove == true) {
      this.driveServiceProvider.moveFolder(this.objSelectedFolder, this.driveServiceProvider.objCurrentFolder, true, this.objMovedSourceFolder);
    }
    this.folderStatusMove = false;
    this.showPaste = false;
    this.objCurrentFolderProperties = {};
  }

  @ViewChild('templateProperties', { read: ViewContainerRef, static: false }) templateProperties: ViewContainerRef;
  openProps(e) {
    if (this.templateProperties != undefined) {
      this.viewContainerRef.clear();
    }
    let shareInfo = { 'sharedFolder': this.objCurrentFolderProperties, 'accessType': 'private', 'pullFolderTemplate': { "client": this.configureService.getStudio(), 'userid': this.configureService.getLoginUserID(), 'app_code': this.configApiService.currentDriveApp['app_code'] } }
    let templateProps = this.currentTemplateProps;
    const componentFactory = this.resolver.resolveComponentFactory(FolderPropertiesComponent);
    this.componentRef = this.viewContainerRef.createComponent(componentFactory);
    this.componentRef.instance.selectTemplates = this.objCurrentFolderProperties;
    this.componentRef.instance.objCurrentFolder = this.objCurrentFolderProperties;
    this.componentRef.instance.objCurrentTemplateProps = templateProps;
    this.componentRef.instance.shareInfo = shareInfo;
    this.componentRef.instance.templateType = 'Multiple';
    this.folderProperty = false;
    this.showMainContainer = false;
  }
  clearPropsComponent() {
    this.viewContainerRef.clear();
    this.showMainContainer = true;
  }

  addFolder() {
    let ProgressCancelClicked = false;
    let alert = this.alertCtrl.create({
      title: 'New Folder',
      inputs: [
        {
          name: 'FolderName',
          placeholder: 'Folder Name'
        }
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: data => {

            ProgressCancelClicked = true;
          }
        },
        {
          text: 'Create',
          handler: data => {
            if (data["FolderName"].trim() == "") {
              const toast = this.toastController.create({
                message: 'Folder Name Cannot be Empty!',
                duration: this.configApiService.toastDuration,
              });
              toast.present();
              this.addFolder();
            } else {
              let foldername: any = this.driveServiceProvider.objCurrentFolder["folders"].find(item => item.name == data.FolderName);
              if (foldername) {
                const toast = this.toastController.create({
                  message: 'Folder Name already exists. Please, create new foldername',
                  duration: this.configApiService.toastDuration
                });
                toast.present();
                this.addFolder();
              } else {
                ProgressCancelClicked = false;
                this.driveServiceProvider.createFolder(data.FolderName);
                this.driveServiceProvider.broadcastInfo({ src: 'drive-main', event: 'showTemplateStatus', status: true });
              }
            }
          }
        }
      ]
    });



    alert.present();
    this.driveService.broadcastInfo({ src: 'drive-main', event: 'showProgressStatus', status: true });
    let events = this.events;
    alert.onDidDismiss(function () {
      if (ProgressCancelClicked == true) {
        this.driveService.broadcastInfo({ src: 'drive-main', event: 'showProgressStatus', status: false });
      }
    });
  }
  @ViewChild('container', { read: ViewContainerRef, static: false }) viewContainerRef: ViewContainerRef;
  openRuleEngine(e) {
    const componentFactory = this.resolver.resolveComponentFactory(RuleEngineSetupComponent);
    this.componentRef = this.viewContainerRef.createComponent(componentFactory);
    this.componentRef.instance.params = this.objCurrentFolderProperties;
    this.componentRef.instance.clear_Component.subscribe(() => { this.clearComponent(); });
    this.showMainContainer = false;
    this.folderProperty = false;
  }

  clearComponent() {
    if (!this.driveServiceProvider.objCurrentFolder) {
      this.driveServiceProvider.objCurrentFolder = this.driveServiceProvider.objRootFolder;
    }
    this.viewContainerRef.clear();
    this.showMainContainer = true;
  }

  @ViewChild('excelUpload', { read: ViewContainerRef, static: false }) excelUpload: ViewContainerRef;
  openImportData(data) {
    if (this.templateProperties != undefined) {
      this.viewContainerRef.clear();
    }
    const componentFactory = this.resolver.resolveComponentFactory(ExcelUploadPage);
    this.componentRef = this.viewContainerRef.createComponent(componentFactory);
    this.componentRef.instance.currentFolderTemplate = data;
    this.componentRef.instance.clear_excelUpload_page.subscribe(() => { this.cleadExcelComponent(); });
    this.showMainContainer = false;
  }

  cleadExcelComponent() {
    this.excelService.resetTemplateFields()
    this.viewContainerRef.clear();
    this.showMainContainer = true;
  }

  getCurrentFolderStoredTemplates() {
    let arrTemplateProps = [];
    if (this.driveService.objCurrentFolder.template.length) {
      for (let idx = 0; idx < this.driveService.objCurrentFolder.template.length; idx++) {
        if (this.driveService.objCurrentFolder.template[idx].id) {
          arrTemplateProps.push(this.driveService.storeWrap.storeTemplates[this.driveService.objCurrentFolder.template[idx].id]);
        }
      }
    }
    return arrTemplateProps;
  }

  addFile() {
    const arrayIdx = 0;
    let arrTemplates = this.getCurrentFolderStoredTemplates();
    if (arrTemplates.length != arrayIdx) {
      this.inlineEditAccess = arrTemplates[arrayIdx].colprops.find(col => col.editable == true);
      if (this.inlineEditAccess) {
        this.driveService.broadcastInfo({ src: 'grid-main', event: 'ediableGrid', data: this.inlineEditAccess });
      } else {
        this.driveService.broadcastInfo({ src: 'drive-main', event: 'showComponentHolder', status: true });
        let paramKeyVal: any = {};
        paramKeyVal[arrTemplates[arrayIdx].sourceKey] = '0';
      }
    }
  }
  @ViewChild('versionHistory', { read: ViewContainerRef, static: false }) versionHistory: ViewContainerRef;
  chatTntActivity(e) {
    this.rowData = e.rowData;
    const rowIndexLen = 0;
    const rowindex = 1;

    if (this.subtemplateid != '') {
      this.template_id = this.driveServiceProvider.storeWrap.storeTemplates[this.subtemplateid];
    } else {
      this.template_id = this.driveServiceProvider.storeWrap.storeTemplates[this.templateID];
    }
    let srcKey = this.template_id["sourceKey"]
    let record_id = this.rowData[srcKey].toString()
    this.ShowTntActivity = true;
    const componentFactory = this.resolver.resolveComponentFactory(VersionHistoryComponent);
    this.componentRef = this.viewContainerRef.createComponent(componentFactory);
    this.componentRef.instance.tntActiveStatus = true;
    if (this.subtemplateid != '') {
      this.componentRef.instance.templateID = this.subtemplateid;
    } else {
      this.componentRef.instance.templateID = this.templateID;
    }
    // this.componentRef.instance.templateID = this.templateID;
    this.componentRef.instance.recordId = record_id;
    this.componentRef.instance.closeTntActivity.subscribe(() => { this.closeTntComponent(); });
    let lastElement = this.row_index[this.row_index.length - rowindex];
    if (this.row_index.length != rowIndexLen && lastElement == e.rowIndex) {
      this.row_index = [];
      this.closeTntComponent();
    }
    else {
      this.row_index.push(e.rowIndex);
    }
  }

  closeTntComponent() {
    this.ShowTntActivity = false;
    this.driveService.broadcastInfo({ src: 'drive', event: 'tntActiveStatus', status: false });
    this.componentRef.instance.closeTntActivity.subscribe(() => { this.closeTntComponent(); });
    this.viewContainerRef.clear();
  }
  openContextMenu(e) {
    this.folderProperty = !this.folderProperty;
    let objCurrentFolder = JSON.parse(this.driveServiceProvider.objOpenFolder)
    if (this.folderProperty == true) {
      this.objCurrentFolderProperties = objCurrentFolder;
      this.oldFolderName = objCurrentFolder["name"];
    }
  }
  exportFolder() {
    if (this.templateProperties != undefined) {
      this.viewContainerRef.clear();
    }
    const componentFactory = this.resolver.resolveComponentFactory(FolderPropertiesComponent);
    this.componentRef = this.viewContainerRef.createComponent(componentFactory);
    this.componentRef.instance.exportFolder = true;
    this.componentRef.instance.selectTemplates = this.objCurrentFolderProperties;
    this.componentRef.instance.templateType = 'Multiple';
    this.folderProperty = false;
    this.showMainContainer = false;
    this.showTemplates = true;

  }
  cbk = ((resp) => {
    console.log(resp)
  })


  pullsubmitSuccess = (responsedata => {
    if (responsedata.length != 0) {
      this.ShareID = responsedata[0]['ShareID'];
      this.objShareInfo = JSON.parse(responsedata[0]["SharedInfo"]);
      this.objShareInformation = JSON.parse(responsedata[0]['ReceiverEmail']);
      this.objShareInformation.forEach(item => {
        this.receiverEmailId.push(item['email_id']);
      })
      this.acceessType = responsedata[0]["AccessType"];
      this.removeUser()
    }
  })

  acceessType: any;
  removeUser() {
    let loginUserDetails = this.configServiceProvider.getLoginData();
    let objIdx = this.receiverEmailId.findIndex(item => item == this.configServiceProvider.getLoginData()["user"])
    var infoIdx = this.objShareInformation.findIndex(item => item['email_id'] == this.configServiceProvider.getLoginData()["user"])
    this.receiverEmailId.splice(objIdx, 1);
    if(this.objShareInformation[infoIdx]['IsWatchAcessFlag'] == 'YES'){
      this.getWatchList();
    }
    this.objShareInformation.splice(infoIdx, 1)
    this.removeUserToSender()
  }

  removeUserToSender() {
    let pushParams = {
      "SharedInfo": this.objShareInfo,
      "ShareType": "Folder",
      "TemplateID": this.currentTemplateProps["id"],
      "ReceiverEmail": JSON.stringify(this.objShareInformation),
      "TemplateName": this.currentTemplateProps['templateName'],
      "AccessType": this.acceessType,
      "UserFolder": this.objCurrentFolder['folder_id'],
      "userid": this.objCurrentFolder["author"]['userID'],
      "ShareID": this.ShareID != undefined ? this.ShareID : ''
    }
    console.log('sharedata', pushParams);
    let pushObjData = Object.assign({}, this.configApiService.driveApi.pushLinkShareUser.params, pushParams);
    this.configApiService.pushRequest(pushObjData, this.submitSuccess);
  }

  submitSuccess = (responsedata => {
  })

  getWatchList() {
    if (this.configApiService.driveApi.pullWatchTab) {
      let objData = Object.assign({}, this.configApiService.driveApi.pullWatchTab.params, { 'userid': this.objCurrentFolder["author"]['userID'], "folderID": this.objCurrentFolder['folder_id'] })
      this.configApiService.pullRequest(objData, (respData) => {
        if (respData.length > 0) {
          const WATCH_DISABLE = 2;
          let watchuserEmaillist = [];
          respData.forEach(element => {
            watchuserEmaillist.push({ email: element.email_id, watchTag: WATCH_DISABLE, accessId: element.accessID, userid: element.Reciever_user_id });
          })
          let watchMessageFlag = 'This Folder removed in watch list!!';
          this.driveServiceProvider.pushWatchAccessApi(watchuserEmaillist,this.currentTemplateProps,this.objCurrentFolder, this.objCurrentFolder["author"]['userID'] );
        }
      })
    }
  }

  ngOnDestroy() {
  }

}


// WEBPACK FOOTER //
// ./src/pages/drive/drive.ts